import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router';

import {
  Container,
  Grid,
  Header,
  Icon,
  List,
  Segment,
} from 'semantic-ui-react';

// Style
import './assets/style.css';

// Image

class Footer extends Component {
  render() {
    return (
      <Segment
        id="footer"
        role="contentinfo"
        inverted
        vertical
        style={{
          padding: '3em 0em 1.5em',
          marginTop: '5em',
          // position: 'absolute',
          // left: '0',
          // bottom: '0',
          // height: '100px',
          // width: '100%',
          // overflow: 'hidden',

          // left: '0',
          position: 'absolute',
          bottom: '0',
          width: '100%',
          height: '150px',
        }}
      >
        <Container>
          <Grid inverted stackable columns="equal">
            <Grid.Row>
              <Grid.Column>
                <Header inverted as="h2" content="Help Desk" />
                <List inverted>
                  <List.Item>
                    <Link
                      href="/external-link/?url=https://ohs-itams.zendesk.com/hc/en-us/requests/new"
                      rel="noopener noreferrer"
                      aria-label="Launch Zendesk external link"
                      style={{ color: 'white' }}
                    >
                      Launch Zendesk{' '}
                      <span className="sr-only">external icon</span>
                      <Icon name="external" />
                    </Link>
                  </List.Item>
                </List>
              </Grid.Column>

              <Grid.Column textAlign="center">
                <Header inverted as="h2" content="Support Hours" />
                <List inverted>
                  <List.Item>Monday - Thursday, 9:00am - 8:00pm ET</List.Item>
                  <List.Item>Friday, 9:00am - 5:00pm ET</List.Item>
                </List>
              </Grid.Column>

              <Grid.Column textAlign="right">
                <Header inverted as="h2" content="Contact Information" />
                <List inverted>
                  <List.Item>
                    <Link href="mailto:support@ohs-itams.zendesk.com">
                      support@ohs-itams.zendesk.com
                    </Link>
                  </List.Item>
                  <List.Item>
                    <Link href="tel:1-866-993-1295">1-866-993-1295</Link>
                  </List.Item>
                </List>
              </Grid.Column>
            </Grid.Row>
          </Grid>

          {/* <Grid>
            <Grid.Row>
              <Grid.Column textAlign="center">
                <Divider inverted section />
                <Image centered src={AMSLogoSquare} width={32} alt="Aligned Monitoring System 2.0 Home" />
                <List horizontal inverted bulleted size="small">
                  <List.Item>
                    Aligned Monitoring System <sup>2.0</sup>
                  </List.Item>
                </List>
              </Grid.Column>
            </Grid.Row>
          </Grid> */}
        </Container>
      </Segment>
    );
  }
}

Footer.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default Footer;
